import React from 'react';
import cn from 'classnames';

const ModalRow = ({
  isHeader = false,
  leftColData,
  rightColData,
  isLast = false,
}) => (
  <div
    className={cn('flex border-b border-l border-r', {
      'border-t rounded-t-0.4': isHeader,
      'rounded-b-0.4': isLast,
    })}
  >
    <div
      className={cn(
        'flex items-center w-1/3 text-14 leading-10 px-4.6 py-4.2',
        {
          'font-medium': isHeader,
        },
      )}
    >
      {leftColData}
    </div>
    <div
      className={cn('border-l w-2/3 text-14 leading-10 px-4.6 py-4.2', {
        'font-medium': isHeader,
      })}
    >
      {rightColData}
    </div>
  </div>
);

export default ModalRow;
